import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'mlp-ng-text-button-external',
    templateUrl: './text-button-external.component.html',
    styleUrls: ['./text-button-external.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextButtonExternalSharedComponent implements OnInit {
    @Input() attributes: {[s: string]: string};
    @Input() label: string;
    @Input() url: string;
    @Input() iconName: string;
    @Input() weight = 'normal';

    @ViewChild('aTag') aTagElement: ElementRef<HTMLElement>;

    ngOnInit(): void {
        if (this.attributes) {
            Object.keys(this.attributes).forEach(key => {
                this.aTagElement.nativeElement.setAttribute(key, this.attributes[key]);
            });
        }
    }
}
